import { Filter } from 'model/Filters';
import FilterPopoverTrigger from 'modules/common/Popovers/FilterPopoverTrigger';
import MoreFiltersPopoverContainer from 'modules/common/Popovers/MoreFiltersPopover/MoreFiltersPopoverContainer';
import usePopoverTrigger from 'modules/common/SubBars/ExperienceFilterSubNavbar/usePopoverTrigger';
import React from 'react';

interface MoreFiltersTriggerProps {
  selectedFilters: Filter[];
}

function MoreFiltersTrigger({ selectedFilters }: MoreFiltersTriggerProps) {
  const { show, togglePopover, closePopover } =
    usePopoverTrigger('more filters');

  const filterOutFilters = [
    'adults',
    'children',
    'date.to',
    'date.from',
    'languages.items[]',
    'other.availability.items[]',
  ];
  const selectedFiltersToShow = selectedFilters.filter(
    (filter) => !filterOutFilters.includes(filter.uid),
  );

  const nrOfActiveFilters: number = selectedFiltersToShow.reduce(
    (acc, curr) => acc + (curr.value ? 1 : curr.subOptions.length),
    0,
  );

  return (
    <FilterPopoverTrigger
      destination="/filter/more/"
      text={`Filters${nrOfActiveFilters ? `: ${nrOfActiveFilters}` : ''}`}
      togglePopover={togglePopover}
      isActive={nrOfActiveFilters > 0}
      show={show}
    >
      <MoreFiltersPopoverContainer
        initialSelectedFilters={selectedFilters}
        onClose={closePopover}
      />
    </FilterPopoverTrigger>
  );
}

export default MoreFiltersTrigger;
